export default "__VITE_ASSET__DSt3c$dL__"